/**
 * 홈 화면 우측 열의 "내가 푼 문제" 안내 카드.
 *
 * StudentHome 이 TodayProblem 옆에 AICard 와 세로로 나란히 배치한다.
 * AICard 와 동일하게 체험용 계정은 클릭 시 실제 이동 대신 접근 제한 모달을 본다.
 */
import React from "react";
import CircleArrowRight from "../icons/CircleArrowRight";
import EditDocument from "../icons/home/EditDocument";
import { useTrialBlock } from "@/hooks/useTrialBlock";

/** 내가 푼 문제 카드. 클릭하면 체험용 계정 접근 제한 모달을 띄운다. */
function SolvedProblems() {
  // 체험용 계정: 내가 푼 문제 진입 대신 접근 제한 모달
  const openTrialBlock = useTrialBlock();
  return (
    <div
      onClick={() => openTrialBlock("내가 푼 문제")}
      className="border border-line h-1/2 problem-card flex justify-between cursor-pointer"
    >
      <div className="flex flex-col gap-y-[10px]">
        <div className="text-18 font-extrabold text-heading font-heading">내가 푼 문제</div>
        <div className="text-16 text-body font-normal">
          <div>풀었던 문제를</div>
          <div>다시 보고 싶은가요?</div>
        </div>
        <CircleArrowRight />
      </div>
      <div className="flex items-end">
        <EditDocument />
      </div>
    </div>
  );
}
export default SolvedProblems;
